<template>
  <div class="Single-white">
    <div class="sw-load" v-if="loading">
      <img title="" src="../../assets/loadingbar.gif" />
      <div class="sw-load-tip">数据加载中...</div>
    </div>
    <div class="item-header" v-if="!loading">个人档案</div>
    <table class="item-content" v-if="!loading">
      <tr>
        <td class="dialog-title">
          学号
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.UserID }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          姓名
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.RealName }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          性别
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Sex == 1 ? '男' : '女' }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          出生日期
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Birthday }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          个人电话号码
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Phone }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          学院
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Academy }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          专业
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Specialty }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          班级
        </td>
        <td class="dialog-cnt">
          {{ tableData.BUser.DeptName }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">入学年份</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.TheEntranceDate }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">年级</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.EntryDate }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">身份证号</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.IDCard }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人姓名</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.TheGuardian }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人电话号码</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.TheGuardianPhone }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人身份</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.TheGuardianRelationShip }}<span
            v-if="(tableData.BUser.Bak19 != undefined && tableData.BUser.Bak19 != '')">（{{
                tableData.BUser.Bak19
            }}）</span>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">学生类型</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Degree }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">是否是贫困生</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Bak20 == "1" ? '是' : '否' }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">生源地</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.NativePlace }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">民族</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.NationValue }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">国籍</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.NationalityValue }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">学籍异动</td>
        <td class="dialog-cnt">
          {{ tableData.BUser.Bak18 }}
        </td>
      </tr>
    </table>

    <tableconfig ref="tableconfig" class="table-config" :isTableNameVisible="false" />
    <div v-for="(item, index) in tableData.TableConfigList" :key="index">
      <div class="item-header">
        {{ item.TableName }}
        <span class="item-time">（{{ item.CreatedDate }}）</span>
        <span class="item-creator">评估人：{{ item.CreatorName }}</span>
      </div>
      <table class="item-content">
        <tr v-for="(citem, cindex) in item.ItemList" :key="cindex">
          <td :class="citem.ItemType == -1 ? 'dialog-tRow' : 'dialog-title'"
            :colspan="citem.ItemType == -1 ? '2' : '1'">
            {{ citem.ItemName }}
          </td>
          <td class="dialog-cnt" v-if="citem.ItemType == 7">
            <div class="img-list" v-for="(it, idx) in citem.AnswerList" :key="idx">
              <el-image style="width: 100%; height: 100%" :src="it" :preview-src-list="citem.AnswerList"
                v-if="it != '' && (it.indexOf('.jpg') > -1 || it.indexOf('.png') > -1)">
              </el-image>
              <p class="link-file"
                v-else-if="it != '' && (it.indexOf('.doc') > -1 || it.indexOf('.docx') > -1 || it.indexOf('.pdf') > -1)"
                @click="OpenFile(it)">
                {{ it
                }}</p>
              <span v-else>【未上传】</span>
            </div>
          </td>
          <td class="dialog-cnt" v-else-if="citem.ItemType != -1 && citem.ItemType != 41">
            {{ citem.AnswerResult }}
          </td>
          <td class="dialog-cnt" v-else-if="citem.ItemType == 41">
            <div v-html="citem.AnswerResult"></div>
          </td>
        </tr>
      </table>
    </div>

    <el-dialog title="请选择导出内容" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
      <div class="dialog-content" :style="{ height: dialogHeight }">
        <div class="dialog-option">
          <div class="export-bar">
            <div class="export-bar-left" @click="ExportFile(0)">
              原始数据(excel)
            </div>
            <div class="export-bar-right" @click="ExportFile(1)">档案(doc)</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="文件导出" :visible.sync="dialogExport" :close-on-click-modal="false" :show-close="false" width="30%">
      <div class="dialog-content" style="text-align: center;">
        <img title="" src="../../assets/loadingbar.gif" style="margin: 10px 0 0 0;" />
        <div class="dialog-tip">
          {{
    this.exportState == 0 ? '正在导出原始数据，' : '正在导出档案，'
          }}请稍等...
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tableconfig from '../../components/my-table-config.vue';

export default {
  components: {
    tableconfig,
  },
  name: 'RPUserArchives',
  data() {
    return {
      UserID: '',
      dialogVisible: false,
      dialogExport: false,
      dialogHeight: '120px',
      tableData: { BUser: { UserID: '' } },
      loading: false,
      exportState: -1,
      DicList: [],
    };
  },

  created() { },
  methods: {
    SetUserInfo: function (citem) {
      this.UserID = citem.UserID;
      this.loading = true;
      //根据UserID获取所有数据
      let _this = this;
      this.$Http_Post('ReportCriData/GetAllUserInfo', { UserID: this.UserID })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.tableData = res.Data;
            _this.loading = false;
            _this.$refs.tableconfig.setTableConfig({
              TableConfig: _this.tableData.BUserTableConfig,
              OptionState: 0,
            });
          } else {
            this.Global.request_failure(res.Message);
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    DoMyExport: function () {
      this.dialogVisible = true;
    },
    ExportFile: function (state) {
      this.exportState = state;
      //0表示导出原始数据(excel文件),1表示导出个人档案Word文件
      this.dialogVisible = false;
      this.dialogExport = true;
      let _this = this;
      this.$Http_Post('ReportCriData/GetUserArchives', {
        UserID: this.UserID,
        ExportState: state,
      })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            window.location.href = res.Data;
          } else {
            this.Global.request_failure(res.Message);
          }
          _this.dialogExport = false;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    OpenFile(filePath) {
      window.open(filePath, '_blank')
    }
  },
  mounted() {
    let _this = this;
    this.$Http_Post('User/DictionaryList')
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.DicList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.message,
        });
      });
  },
};
</script>
<style>
.Single-white {
  padding: 10px;
  height: calc(100% - 85px);
  position: relative;
  overflow: auto;
}

.dialog-tRow {
  text-align: center;
  font-weight: bold;
}
</style>
